export enum ECurrentUserGroupStatus {
    EMPTY,
    EDIT,
    NEW
}
export enum EUserGroupMenuOptions {
  ManageUserGroup = 1,
  EditUserGroup = 2,
  ManageConditions = 3
}
